<template>
  <div>
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item label="" prop="searchContent">
          <el-input
            style="width:300px"
            :maxlength="100"
            v-model="searchForm.searchContent"
            placeholder="搜索商品ID、名称"
          />
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column
        prop="id"
        label="商品ID"
        width="230"
      >
        <template slot-scope="scope">
          {{ scope.row.thirdProductId }}
          <el-tag
          v-if="scope.row.thirdProductId"
          v-clipboard:copy="scope.row.thirdProductId"
          v-clipboard:success="onCopy"
          style="cursor: pointer;"
          size="mini"
        >复制</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="商品名称" />
      <el-table-column prop="createTime" label="创建时间" width="180" />
      <el-table-column label="推广中达人" width="150">
        <template slot-scope="scope">
<!--          <el-avatar-->
<!--            :src="scope.row.promoter.avatar"-->
<!--            size="small"-->
<!--            style="vertical-align: middle"-->
<!--          ></el-avatar>-->
          <span style="margin-left: 8px;">
            {{ scope.row.darenNum }}个达人
          </span>
        </template>
      </el-table-column>
      <el-table-column label="计划内容" prop="typeJoinStr">
<!--        <template slot-scope="scope">-->
<!--          <span v-for="(plan, idx) in scope.row.plans" :key="plan" style="margin-right: 8px;">-->
<!--            <a href="#" style="color: #409EFF">{{ plan }}</a>-->
<!--            <span v-if="idx < scope.row.plans.length - 1">/</span>-->
<!--          </span>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column label="操作" width="120" align="left">
        <template slot-scope="{row}">
          <el-link type="text" @click="handleManage(row)">
            <i class="el-icon-setting"></i> 管理计划
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tableList.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total"
    >
    </el-pagination>
    <manageDetailPop ref="manageDetailPopRef" @refresh="handleRefresh"></manageDetailPop>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import manageDetailPop from './manageDetailPop.vue';
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  name: "manageList",
  components: {
    manageDetailPop,
  },
  data() {
    return {
      searchForm: {
        searchContent: '',
      },
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[
          // {
          //   id: 89757234,
          //   name: '15代金券',
          //   createTime: '2025.06.23',
          //   promoter: { avatar: 'https://randomuser.me/api/portraits/women/1.jpg', count: 3 },
          //   plans: ['通用', '短视频定向', '自指定向'],
          // },
          // {
          //   id: 89757235,
          //   name: '不要钱的代金券',
          //   createTime: '2025.06.23',
          //   promoter: { avatar: 'https://randomuser.me/api/portraits/men/2.jpg', count: 1 },
          //   plans: ['通用'],
          // },
        ],
      },
    }
  },
  created() {
    this.getList();
  },
  methods:{
    handleRefresh() {
      console.log('handleRefresh===112222333333')
      this.reset()
      this.getList();
    },
    handleManage(row){
      console.log(row,'handleManage')
      this.$refs.manageDetailPopRef.open(2,row)
    },
    async getList() {
      this.loading = true
      const res = await MiniModel.dyLifePlanSearch({
        ...this.searchForm,
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      console.log(res,'getListgetList')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val;
      this.getList();
    },
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
  },
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/manageList.vue